import EndpointHelper from '../../../common/endpoints/EndpointHelper';

const Endpoint = {
  GET_NEXT_OCCURRENCES: '/cmms/rule/get-next-occurrences',
  GET_OCCURRENCES_RANGE: '/cmms/rule/get-occurrences-range',
  GET_FREQUENCIES: '/cmms/rule/get-frequencies',
  GET_FREQUENCY: '/cmms/rule/get-frequency',
  GET_BY_TICKET_ID: '/cmms/rule/get-by-ticket-id',
  LIST_TICKETS: '/cmms/rule/list-tickets',
  LIST: '/cmms/rule/list',
  SAVE: '/cmms/rule/save',
  REMOVE: '/cmms/rule/remove',
  ...EndpointHelper,
};

/**
 [Vue migration] Developer Note
 This component has a twin version for both Vue 2 and Vue 3 projects.
 When making changes, remember to update and test both versions.
 */
export default Endpoint;
